"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoAIPresenter = void 0;
const periodTypes_1 = __importDefault(require("../table/v1/periodTypes"));
const autoAI_1 = require("../view/components/autoAI/model/autoAI");
class AutoAIPresenter {
    viewModel;
    constructor() { }
    setViewModel(viewModel) {
        this.viewModel = viewModel;
    }
    setIsLoading(isLoading) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.isLoading = isLoading;
    }
    setIsVisible(isVisible) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.isVisible = isVisible;
    }
    showCreateEditOptions() {
        this.setScreen(autoAI_1.AutoAIScreen.CREATE_EDIT_OPTIONS);
    }
    showRolesSelection() {
        this.setScreen(autoAI_1.AutoAIScreen.ROLES);
    }
    showShiftGenerator() {
        this.setScreen(autoAI_1.AutoAIScreen.SHIFT_GENERATOR);
    }
    setScreen(screen) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.screen = screen;
    }
    setScheduleMode(mode) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.scheduleMode = mode;
    }
    setCheckedRoles(ids) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.checkedRoles = [...ids];
    }
    toggleAllCheckedRoles(selectAll) {
        if (!this.viewModel) {
            return;
        }
        if (selectAll) {
            this.viewModel.checkedRoles = (this.viewModel.roles ?? []).map(r => r.getOriginalId());
        }
        else {
            this.viewModel.checkedRoles = [];
        }
    }
    setIntructions(text) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.instructions = text;
    }
    setSendSkills(sendSkills) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.sendSkills = sendSkills;
    }
    setSendODays(sendODays) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.sendODays = sendODays;
    }
    setProvider(provider) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.provider = provider;
    }
    setTaskDone(isDone, notesJapanese) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.isDone = isDone;
        this.viewModel.notesJapanese = notesJapanese || "";
    }
    setReloadOnDone(reload) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.reloadOnDone = reload;
    }
    setPromptHistory(history) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.promptHistory = [...history];
    }
    addPromptHistory(prompt) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.promptHistory = [prompt, ...(this.viewModel.promptHistory || [])];
    }
    updatePromptHistory(prompt) {
        if (!this.viewModel) {
            return;
        }
        const index = this.viewModel.promptHistory.findIndex(p => p.id === prompt.id);
        if (index === -1) {
            return;
        }
        this.viewModel.promptHistory[index] = prompt;
        this.viewModel.promptHistory.sort((a, b) => b.date.localeCompare(a.date));
    }
    deletePromptHistory(promptId) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.promptHistory = this.viewModel.promptHistory.filter(p => p.id !== promptId);
        if (this.viewModel.selectedPromptId === promptId) {
            this.viewModel.selectedPromptId = "";
        }
    }
    selectPrompt(prompt) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.instructions = prompt.message;
        this.viewModel.selectedPromptId = prompt.id;
    }
    clear() {
        const isDayView = this.viewModel?.timePeriodType === periodTypes_1.default.DAY;
        this.setTaskDone(false, "");
        if (isDayView) {
            this.showRolesSelection();
        }
        else {
            this.showCreateEditOptions();
        }
        this.setScheduleMode(autoAI_1.AutoAIScheduleMode.CREATE);
        this.setIsLoading(false);
        this.toggleAllCheckedRoles(false);
        this.setReloadOnDone(true);
        this.setSendSkills(false);
        this.setSendODays(false);
    }
}
exports.AutoAIPresenter = AutoAIPresenter;
